import { filterObjectValuesByKeys } from '../object/filterObjectValuesByKeys'

export const filterArrayOfObjectValuesByKeys = (
  array: Record<string, any>[] = [],
  keys: Record<string, any> = {}
) => array.map((object) => filterObjectValuesByKeys(object, keys))
